export default __webpack_public_path__ + "static/media/linkedin.bbf07169.svg";